import React from 'react'
import Layout from "../components/Layout";
import Products from "../components/Products";

const shop = () => {
   return (
      <Layout className="relative">
         <Products/>
      </Layout>
   )
}

export default shop
